import { Pipe, PipeTransform } from '@angular/core';
import { PriceOverride } from './interface';

@Pipe({
  name: 'priceOverride',
})
export class PriceOverridePipe implements PipeTransform {
  transform(value: PriceOverride): string {
    switch (value) {
      case 'CONTACT SALES':
        return 'Contact Sales';
      case 'FREE':
        return 'Free';
    }
  }
}
